// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"475fa84f","373":"fb13740d","453":"3091a3d3"}[chunkId] + ".chunk.js";
};